<template>
  <div>
    <PatientList
      :patients="patients"
      :totalDocs="totalDocs"
      :page="page"
      @fetchList="getPatientsList"
      @viewPatientDetail="patientDetail"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import PatientList from '../../components/patients/List';

export default {
  components: {
    PatientList,
  },
  data() {
    return {
      totalDocs: 0,
      page: 1,
      patients: [],
    };
  },
  methods: {
    ...mapActions('orgOwner', ['getPatients']),
    async getPatientsList(dataTableParams) {
      let self = this;
      this.getPatients(dataTableParams).then(res => {
        self.patients = res.data.data.docs;
        self.totalPage = res.data.data.pagination.total;
        self.totalDocs =
          res.data.data.pagination.total
            ? res.data.data.pagination.total
            : 0;
        self.page =
          res.data.data.pagination.page
            ? res.data.data.pagination.page
            : 1;
      });
    },
    patientDetail(id) {
      this.$router.push({
        name: 'NursePatientDetail',
        params: { patientId: id },
      });
    },
  },
};
</script>
